import { MapPin } from "lucide-react";
import Reveal from "@/components/Reveal";

export function ResumeExperience({ experience }) {
  return (
    <section className="max-w-5xl mx-auto px-6 sm:px-10 mt-20">
      <Reveal>
        <h2 className="font-display text-4xl sm:text-5xl tracking-tight mb-10 t-heading">Experience</h2>
      </Reveal>
      <div className="space-y-6">
        {experience.map((e, i) => (
          <Reveal key={`${e.company}-${e.period}`} delay={(i % 3) * 0.06}>
            <div className="bg-[#FBF9F4] border border-[#E7DFD0] rounded-3xl shadow-[0_8px_30px_-14px_rgba(28,24,21,0.16)] p-7 sm:p-9">
              <div className="flex flex-wrap items-baseline justify-between gap-2">
                <h3 className="font-display text-2xl sm:text-3xl tracking-tight">{e.role}</h3>
                <span className="font-mono-brand text-xs uppercase tracking-[0.12em] text-[var(--brand-muted)]">{e.period}</span>
              </div>
              <p className="mt-1 font-bold text-[var(--brand-primary)]">{e.company}{e.location ? <span className="text-[var(--brand-muted)] font-medium inline-flex items-center gap-1"> · <MapPin size={13} /> {e.location}</span> : null}</p>
              <ul className="mt-5 space-y-3">
                {(e.points || []).map((p) => (
                  <li key={p} className="flex gap-3 text-[#3F3933] leading-relaxed font-medium">
                    <span className="mt-2 w-1.5 h-1.5 rounded-full bg-[var(--brand-primary)] shrink-0" />
                    <span>{p}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}

export function ResumeSkillsEdu({ r }) {
  return (
    <section className="max-w-5xl mx-auto px-6 sm:px-10 mt-16 grid lg:grid-cols-2 gap-10">
      <Reveal>
        <div>
          <h2 className="font-display text-4xl tracking-tight mb-8 t-heading">Expertise</h2>
          <div className="space-y-6">
            {(r.skills || []).map((s) => (
              <div key={s.group}>
                <p className="font-mono-brand text-xs uppercase tracking-[0.14em] text-[var(--brand-muted)] mb-3">{s.group}</p>
                <div className="flex flex-wrap gap-2">
                  {(s.items || []).map((it) => (
                    <span key={it} className="text-sm font-semibold px-3 py-1.5 rounded-full bg-[#EFE7D8] text-[var(--brand-heading)]">{it}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </Reveal>
      <Reveal delay={0.1}>
        <div className="space-y-10">
          <div>
            <h2 className="font-display text-4xl tracking-tight mb-6 t-heading">Education</h2>
            <div className="space-y-4">
              {(r.education || []).map((ed) => (
                <div key={ed.school}>
                  <p className="font-bold text-[var(--brand-heading)]">{ed.school}</p>
                  <p className="text-[var(--brand-muted)] font-medium">{ed.detail}</p>
                </div>
              ))}
            </div>
          </div>
          {r.certifications?.length > 0 && (
            <div>
              <h3 className="font-mono-brand text-xs uppercase tracking-[0.14em] text-[var(--brand-muted)] mb-3">Certifications</h3>
              <ul className="space-y-2">
                {r.certifications.map((c) => (
                  <li key={c} className="text-[#3F3933] font-medium flex gap-2"><span className="text-[var(--brand-primary)]">›</span> {c}</li>
                ))}
              </ul>
            </div>
          )}
          {r.awards?.length > 0 && (
            <div>
              <h3 className="font-mono-brand text-xs uppercase tracking-[0.14em] text-[var(--brand-muted)] mb-3">Recognition</h3>
              <ul className="space-y-2">
                {r.awards.map((a) => (
                  <li key={a} className="text-[#3F3933] font-medium flex gap-2"><span className="text-[var(--brand-primary)]">★</span> {a}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </Reveal>
    </section>
  );
}
